import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const PageContainer = styled.div`
  max-width: 900px;
  margin: 4rem auto;
  padding: 0 2rem;
  text-align: left;
`;

const PageTitle = styled.h1`
  font-size: 2.8rem;
  text-align: center;
  margin-bottom: 3rem;
  color: #333;
`;

const Section = styled.section`
  margin-bottom: 2.5rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.8rem;
  color: #005eb8;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e0e0e0;
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  margin-bottom: 1rem;
`;

const List = styled.ul`
  list-style-position: inside;
  padding-left: 1rem;
  margin-bottom: 1rem;
`;

const ListItem = styled.li`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  margin-bottom: 0.5rem;
`;

const TermsAndConditions = () => {
    return (
        <PageContainer>
            <PageTitle>Terms & Conditions</PageTitle>

            <Section>
                <Paragraph>
                    Welcome to The Letter Doctor. These terms and conditions outline the rules and regulations for the use of The Letter Doctor's Website, located at [Your Website URL].
                </Paragraph>
                <Paragraph>
                    By accessing this website we assume you accept these terms and conditions. Do not continue to use The Letter Doctor if you do not agree to take all of the terms and conditions stated on this page.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>1. Our Services</SectionTitle>
                <Paragraph>
                    The Letter Doctor provides a range of medical letters, certificates, and referral services ("Services"). All Services are provided by UK-based, GMC-registered doctors. Our service is designed for convenience and is not intended to replace a full consultation with your regular GP or for medical emergencies.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>2. User Obligations</SectionTitle>
                <Paragraph>As a user of our Services, you agree to:</Paragraph>
                <List>
                    <ListItem>Provide accurate, complete, and truthful information in all questionnaires and communications.</ListItem>
                    <ListItem>Be at least 18 years of age. If you are requesting a service for a minor, you must be their legal guardian.</ListItem>
                    <ListItem>Use our Services for their intended purpose only and not for any fraudulent or illegal activities.</ListItem>
                    <ListItem>Understand that our doctors can only provide a letter or certificate if it is clinically appropriate and safe to do so based on the information you provide.</ListItem>
                </List>
            </Section>

            <Section>
                <SectionTitle>3. Payments, Refunds and Cancellations</SectionTitle>
                <Paragraph>
                    All prices for our Services are listed on the website and are inclusive of any applicable taxes. Payment must be made in full at the time of request.
                </Paragraph>
                <Paragraph>
                    A full refund will be provided if one of our doctors determines that they are unable to issue the requested medical document for any clinical reason.
                </Paragraph>
                <Paragraph>
                    Once a medical document has been issued and sent to you, we are unable to offer a refund. If you wish to cancel your request, you must do so before a doctor has reviewed your case. Please contact us immediately if you wish to cancel.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>4. Limitation of Liability</SectionTitle>
                <Paragraph>
                    The Letter Doctor provides services on an "as is" basis. While we strive for accuracy and high quality, we make no warranties regarding the acceptance of our documents by third parties (e.g., employers, airlines, insurance companies), although they are widely accepted. It is your responsibility to confirm the suitability of our documents for your specific needs.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>5. Governing Law</SectionTitle>
                <Paragraph>
                    These terms and conditions are governed by and construed in accordance with the laws of England and Wales and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>6. Contact Us</SectionTitle>
                <Paragraph>
                    If you have any questions about these Terms and Conditions, please <Link to="/contact">contact us</Link>.
                </Paragraph>
                <Paragraph>
                    Last updated: {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}
                </Paragraph>
            </Section>
        </PageContainer>
    );
};

export default TermsAndConditions;